export default __webpack_public_path__ + "static/media/01d_fold-4.ceb05ca7.mp4";